function initCactusFit() {
  document.querySelectorAll('[data-cr-fit]').forEach(root => {
    if (root.dataset.initialized || !window.CactusFit) return;
    root.dataset.initialized = 'true';
    let data;
    try { data = JSON.parse(root.querySelector('[data-cr-fit-data]').textContent); } catch (_) { return; }
    const get = name => root.querySelector('[data-' + name + ']');
    const results = get('results');
    const brand = get('brand');
    const model = get('model');
    const blankModel = model.options[0].textContent;
    const option = (value, text) => Object.assign(document.createElement('option'), { value, textContent: text });
    [...new Set(data.records.map(r => r.brand))].sort().forEach(b => brand.append(option(b, b)));
    brand.append(option('other', data.strings.other));
    const text = (key, replacements = {}) => {
      let value = data.strings[key] || '';
      Object.entries(replacements).forEach(([k, v]) => {
        value = value.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), String(v));
      });
      return value;
    };
    const paragraph = (key, className, replacements) => {
      const p = document.createElement('p'); p.textContent = text(key, replacements);
      if (className) p.className = className;
      return p;
    };
    const read = () => ({
      transport: get('transport').value, gear: get('gear').value,
      skis: get('transport').value === 'car' ? get('car-pairs').value : get('skis').value,
      boards: get('boards').value, skiType: get('ski-type').value,
      brand: brand.value, model: model.value
    });
    function render() {
      const input = read();
      const roof = input.transport === 'roof';
      const car = input.transport === 'car';
      const boardOnly = input.gear === 'boards';
      const show = {
        skis: !boardOnly && !car, 'car-pairs': !boardOnly && car,
        boards: input.gear !== 'skis', 'ski-type': !boardOnly,
        matrix: roof, 'pickup-note': input.transport === 'pickup',
        'roof-note': roof && boardOnly, 'mixed-note': input.gear === 'mixed'
      };
      root.querySelectorAll('[data-area]').forEach(el => {
        const visible = !!show[el.dataset.area];
        el.hidden = !visible;
        el.querySelectorAll('input,select').forEach(control => control.disabled = !visible);
      });
      model.disabled = !show.matrix || !brand.value || brand.value === 'other';
      const gearHeading = get('gear-heading');
      gearHeading.textContent = roof ? gearHeading.dataset.roofLabel : gearHeading.dataset.otherLabel;
      const output = window.CactusFit.evaluate(data, input);
      results.replaceChildren();
      if (input.gear === 'mixed' && output.spaces > 0) {
        results.append(paragraph('mix_total', 'cr-mixed-total', { skis: output.skis, boards: output.boards, total: output.spaces }));
      }
      if (!output.choices.length) {
        if (output.status !== 'matrix_needed') results.append(paragraph(output.status === 'invalid' ? 'empty' : output.status));
        if (['none', 'car_board_check'].includes(output.status) || (output.status === 'matrix_needed' && input.brand === 'other')) {
          const link = document.createElement('a'); link.className = 'cr-button'; link.href = data.contact;
          link.textContent = data.strings.contact; results.append(link);
        }
        return;
      }
      const heading = document.createElement('h3'); heading.textContent = data.strings.result; results.append(heading);
      results.append(paragraph(output.status, 'cr-small'));
      output.choices.forEach(item => {
        const card = document.createElement('a'); card.className = 'cr-fit-result'; card.href = item.url;
        const name = document.createElement('strong'); name.textContent = item.title;
        const price = document.createElement('span'); price.textContent = item.price;
        const action = document.createElement('span'); action.className = 'cr-fit-result-action';
        action.append(document.createTextNode(data.strings.view + ' '), get('fit-arrow').content.cloneNode(true));
        card.append(name, price, action);
        if (item.straps) {
          const included = document.createElement('span'); included.className = 'cr-small cr-fit-included';
          included.textContent = data.strings.included + ': ' + item.straps; card.append(included);
        }
        results.append(card);
      });
      if (output.skis > 0) {
        const aside = document.createElement('aside'); aside.className = 'cr-fit-accessory';
        const title = document.createElement('h3'); title.textContent = data.strings.straps_title;
        const link = document.createElement('a'); link.href = data.strapsUrl; link.className = 'cr-text-link';
        link.textContent = data.strings.straps_link;
        aside.append(title, paragraph('straps_body'), paragraph('straps_recommend', 'cr-small', { count: output.skis }), link);
        results.append(aside);
      }
    }
    brand.addEventListener('change', () => {
      model.replaceChildren(option('', blankModel));
      [...new Set(data.records.filter(r => r.brand === brand.value).map(r => r.model))].sort()
        .forEach(m => model.append(option(m, m)));
      render();
    });
    root.querySelectorAll('select,input').forEach(el => {
      if (el !== brand) el.addEventListener('change', render);
      if (el.tagName === 'INPUT') el.addEventListener('input', render);
    });
    render();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCactusFit);
else initCactusFit();
document.addEventListener('shopify:section:load', initCactusFit);
